import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import Switch from 'react-switch';
import Nodata from '../../assets/images/nodataImg.png';

const SKELETON_COUNT = 4;
const formatStoredDate = (isoString) =>
  isoString ? moment.utc(isoString).local().format('DD MMM YYYY') : '—';

const CouponSkeleton = () => (
  <div className="wp-coupon-skel">
    <div className="wp-skel-stub wp-skel-shimmer" />
    <div className="wp-skel-body">
      <div className="wp-skel-line wp-skel-shimmer" style={{ width: '60%' }} />
      <div className="wp-skel-line wp-skel-shimmer" style={{ width: '85%' }} />
      <div className="wp-skel-line wp-skel-shimmer" style={{ width: '40%' }} />
    </div>
  </div>
);

const AllGetPromoCode = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [togglingId, setTogglingId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      const token = localStorage.getItem('accessTokenAdmin');
      const apiUrl = 'https://production.washta.com/api/admin/promoCode';

      try {
        setLoading(true);
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data.data.reverse());
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleToggle = async (id, isActive) => {
    const token = localStorage.getItem('accessTokenAdmin');
    const apiUrl = `https://production.washta.com/api/admin/promoCode/${id}`;
    const newStatus = !isActive;

    setTogglingId(id);
    try {
      await axios.patch(
        apiUrl,
        { isActive: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData((prevData) =>
        prevData.map((item) =>
          item._id === id ? { ...item, isActive: newStatus } : item
        )
      );
    } catch (err) {
      console.log(err.message);
    } finally {
      setTogglingId(null);
    }
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem('accessTokenAdmin');
    const apiUrl = `https://production.washta.com/api/admin/promoCode/${id}`;

    setDeletingId(id);
    try {
      await axios.delete(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setData((prevData) => prevData.filter((promo) => promo._id !== id));
    } catch (err) {
      console.log('Error deleting promo code:', err.message);
    } finally {
      setDeletingId(null);
    }
  };

  if (loading) {
    return (
      <div className="wp-coupon-grid">
        {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
          <CouponSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="wp-empty">
        <img src={Nodata} alt="No promo codes yet" />
        <p className='po-subtitle'>No promo codes yet. Create one above to see it here.</p>
      </div>
    );
  }

  return (
    <div className="wp-coupon-grid">
      {data.map((promo) => (
        <div className="wp-coupon wp-coupon-item" key={promo._id}>
          <div className="wp-coupon-stub">
            <span className="wp-value">
              {promo.discount}
              {promo?.Discounttype === 'percentage' ? '%' : ''}
            </span>
            <span className="wp-unit">off</span>
          </div>
          <div className="wp-coupon-divider" />
          <div className="wp-coupon-body">
            <div className="wp-coupon-row">
              <span className="wp-code">{promo.promoCode}</span>
              <div className="wp-coupon-actions">
                <Switch
                  onChange={() => handleToggle(promo._id, promo.isActive)}
                  checked={promo.isActive}
                  disabled={togglingId === promo._id}
                  onColor="#6C5CE7"
                  offColor="#D8D9E6"
                  handleDiameter={16}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 4px rgba(0,0,0,0.25)"
                  height={18}
                  width={34}
                />
                <button
                  type="button"
                  className="wp-icon-btn"
                  onClick={() => handleDelete(promo._id)}
                  disabled={deletingId === promo._id}
                  aria-label={`Delete promo code ${promo.promoCode}`}
                >
                  <FaTrash />
                </button>
              </div>
            </div>
            <div className="wp-meta">
              {promo.giveToAll ? 'Applies to all customers' : `Applies to ${promo.giveTo?.length || 0} customer(s)`}
              <br />
              {formatStoredDate(promo.duration.startTime)} – {formatStoredDate(promo.duration.endTime)}
            </div>
            <div className="wp-badges">
              <span className={`wp-badge ${promo.isActive ? 'wp-badge-active' : 'wp-badge-inactive'}`}>
                {promo.isActive ? 'Active' : 'Inactive'}
              </span>
              <span className={`wp-badge ${promo.multiUse ? 'wp-badge-active' : 'wp-badge-inactive'}`}>
                {promo.multiUse ? 'Multi-use' : 'Single-use'}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AllGetPromoCode;